import { useEffect, useState } from 'react'
import type { TmsLoadRow } from '@numeo/types-main-web-app'
import { Skeleton } from '@/components/ds2'
import { useInvoicingRowsStore } from '../../invoicing/rowsStore'
import { InvoicingRowsTable } from '../invoicing/InvoicingTable'
import { LoadsTable } from './LoadsTable'

interface SingleLoadAnswerProps {
    cardId: string
    load: TmsLoadRow
    timezone?: string
    question?: string
    onSend: (message: string) => void
}

/** The skeleton's height: one table row with its filters, so the table does not push the thread when it arrives. */
const ROW_TABLE_HEIGHT = 120

/**
 * One load an answer named (`tms_loads.list` for that load). v17 shows loads only as the in-chat table's rows: a delivered load is its
 * invoicing row in the same table as every invoicing answer (its status, documents, amount, Review and the drawer); any other load is
 * one load line. A delivered load the invoicing read does not list stays a load line.
 */
export const SingleLoadAnswer = ({ cardId, load, timezone, question, onSend }: SingleLoadAnswerProps) => {
    const number = load.load_number ?? undefined
    const invoicing = load.status === 'delivered' && !!number
    const row = useInvoicingRowsStore((state) => (number ? state.rows[number] : undefined))
    const [read, setRead] = useState(false)

    useEffect(() => {
        if (!invoicing || !number) return
        let live = true
        void useInvoicingRowsStore
            .getState()
            .refresh([number])
            .catch(() => undefined)
            .finally(() => {
                if (live) setRead(true)
            })
        return () => {
            live = false
        }
    }, [invoicing, number])

    if (invoicing && row) return <InvoicingRowsTable messageId={cardId} rows={[row]} question={question} offerFactoring={false} />
    if (invoicing && !read)
        return (
            <div role="status" aria-label={`Reading load #${number}`}>
                <Skeleton height={ROW_TABLE_HEIGHT} radius={10} />
            </div>
        )
    return <LoadsTable rows={[load]} timezone={timezone} onSend={onSend} />
}
